import React, {useContext} from 'react'
import { SectionContext } from "../context/sectionContext"
import { JourneyContext } from '../context/journeyContext'
import { withPrefix } from "gatsby"

export default function ComponentBannarFlexiEdge(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  return (
    <>
        <style>
            {`

            .shadow-box-card{
                background-color: #fff;
                box-shadow: 0px 0px 10px #ccc;
                border-radius: 10px;
                padding: 0px 0px;
                float: left;
                width: 100%;
                margin-bottom: 30px;
                height: 172px;
            }
            .gds-center {
                text-align: center;
            }
            .gds-box {
                background-color: ${journeyState.channel === "A" ? "#fff" : "#ededed"};
                padding: 20px 30px;
                border-radius: 14px;
                display: inline-block;
                width: 400px;
                margin: auto;
                text-align: center;
                margin: 20px 0px;
                margin-bottom: 0px;
            }
            .gds-img {
                float: left;
                margin-right: 12px;
                width: 100px;
                text-align: center;
            }
            .gds-text {
                float: left;
                text-align: center;
                padding-top: 5px;
            }
            .gds-text p {
                margin: 0px;
                font-size: 18px;
                font-weight: bold;
                color: #58585a;
            }
            .gds-text h1 {
                margin: 0px;
                font-size: 37px;
                font-weight: bold;
                color: #58585a;
            }
            .gds-text h1 span {
                font-size: 34px;
            }
            img {
                vertical-align: center
            }

            `}

        </style>
        <div class="iselect-mg-bottom ">
            <hr class="hr-line sumAssuredShow" />
            <div class="col-lg-12">
                <div class="radio-section-design sumAssuredShow">
                    <div class="col-lg-12 col-12 gds-center ">
                        <div class="gds-box">
                            <div class="gds-img">
                                <img src={withPrefix("/images/icon-gds-flexiEdge.png")} />
                            </div>
                            <div class="gds-text">
                                <p>Guaranteed Sum Assured</p>
                                <h1><span class="fa fa-rupee"></span>{sectionState.sectionData["sumAssured"]}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )

}



